import React from 'react';
import DatePicker from 'react-datepicker';
import { DateTime } from 'luxon';
import cc from 'classcat';
import 'react-datepicker/dist/react-datepicker.css';

export const TimePicker = ({ value, onChange, placeholder = 'Select time', className, maxTime, minTime }) => {
    return (
        <DatePicker
            selected={value}
            onChange={onChange}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            timeCaption="Time"
            dateFormat="HH:mm"
            timeFormat="HH:mm"
            placeholderText={placeholder}
            className={cc(['default-input', className])}
            maxTime={maxTime ? maxTime : DateTime.now().endOf('day').toJSDate()}
            minTime={minTime ? minTime : DateTime.now().startOf('day').toJSDate()}
        />
    );
};
